import { useQuery } from 'react-query';

import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';
import { SellerConfiguration } from '@savgroup-front-common/types';
import { SellerService } from '@/api';

interface UseGetSellerConfigurationByIdReturnValue {
  data?: SellerConfiguration;
  isLoading: boolean;
}

const useGetSellerConfigurationById = ({
  sellerId,
}: {
  sellerId: string;
}): UseGetSellerConfigurationByIdReturnValue => {
  const { pushErrors } = useToasts();

  const { data, isLoading } = useQuery(
    ['useGetSellerConfigurationById', { sellerId }],
    async () => {
      if (!sellerId) {
        return undefined;
      }

      const response = await SellerService.getSellerConfigurationById({
        sellerId,
      });

      if (response.failure) {
        pushErrors(response.errors);

        return undefined;
      }

      return response.value;
    },
    {
      staleTime: Infinity,
    },
  );

  return { data, isLoading };
};

export default useGetSellerConfigurationById;
